import GameIds from '../hub/data/GameIds';

// TODO : consider changing 'activity' key to 'current'
const initialState = {
  activity: 'loading',
  previous: null,
  isQuestWorkflow: false,
  params: {},
};

const selectedActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_LOADING_SCREEN':
      return {
        ...state,
        previous: state.activity,
        activity: 'loading',
        params: {},
      };
    case 'SELECT_ACTIVITY': {
      const { isLink } = action.payload.params || {};

      if (isLink) {
        return {
          ...state,
          previous: action.payload.activity,
          activity: action.payload.activity,
          isQuestWorkflow: false,
          params: action.payload.params,
        };
      }
      return {
        ...state,
        previous: state.activity,
        activity: action.payload.activity,
        isQuestWorkflow: !!action.payload.isQuestWorkflow,
        params: action.payload.isQuestWorkflow ? action.payload.params : {},
      };
    }
    case 'SELECT_HOME':
    case 'SELECT_HUB_SCREEN': // if selecting a hub screen, make sure we're on the hub
      return {
        ...state,
        previous: state.activity,
        activity: GameIds.HUB,
      };

    default:
      return state;
  }
};

export default selectedActivityReducer;
